<template>
  <div class="flex-grow-1 col-12 p-0 d-flex flex-column">
    <loading />
    <section class="flex-grow-1 d-flex flex-column iframe__container">
      <iframe
        id="paymentIframe"
        class="col-12 flex-grow-1 p-0"
        :src="iframe"
        frameborder="0"
      ></iframe>
    </section>
  </div>
</template>
<style scoped>
iframe {
  height: 100%;
  width: 100%;
  border: none;
  display: block;
}
</style>
<script>
import loading from '../ImgLoading/loading'

export default {
  data: function () {
    return {
      // Response
      iframe: "",
    };
  },
  components: {
    loading
  },
  props: {
    data: Object,
  },
  methods: {
    async pay() {
      const payload = {
        metodo: "NETPAY",
        data: this.data,
      };
      const response = await this.$store.dispatch("metodoPost", payload);

      if (response) {
        const parsedResponse = JSON.parse(
          this.$store.getters.getRespuestaREST.urlPago
        );
        this.iframe = parsedResponse.hostedCheckoutUrl;
        // window.open(parsedResponse.hostedCheckoutUrl);
      }
    },
  },
  mounted() {
    this.pay();
  },
  beforeDestroy() {
    this.$emit("onExit");
  },
};
</script>